/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateScheduleTransferRequest = {
    properties: {
        scheduleId: {
    type: 'number',
    isRequired: true,
},
        fromAssigneeId: {
    type: 'number',
    isRequired: true,
},
        toAssigneeId: {
    type: 'number',
    isRequired: true,
},
    },
};